# Basically handles search input box on course index/category/author bio pages

onPage = (selector) -> (selector).length > 0

selectors =
  pagination: ".pagination .last"
  searchInput: "#search-courses"

paginated = ->
  onPage(selectors.pagination)


ready = ->
  queryParams = -> $.url(document.location.href).param()

  # don't run unless search box is on page
  return unless onPage(selectors.searchInput)
  searchBox = $(selectors.searchInput)


  # grab query and page param
  urlSearchQuery = queryParams().query

  # if there's a query param in query string, put it in search box
  searchBox.val(urlSearchQuery) if urlSearchQuery
  # if there's no pagination or search query, use inline search is
  if $(".pagination .last").length is 0
    $("#search-courses").hideseek()

$(document).ready(ready)
$(document).on('page:change', ready)
